import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './firebaseConfig'; // initializes Firebase (local credentials)
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
// `onUpdate` dispara quando um service worker novo ficou em espera — ou seja,
// quando há versão publicada que esta aba ainda não está usando. Antes o
// `register()` era chamado sem nada: a atualização era detectada e ninguém era
// avisado, e a pessoa seguia na versão velha até fechar todas as abas.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.dispatchEvent(new CustomEvent('mago:nova-versao', { detail: registration }));
  },
});
